import React from 'react';

const PerfilDocenteConProgreso = () => {
  // Datos simulados del perfil del docente
  const docente = {
    nombre: 'María Rodríguez',
    correo: 'maria.rodriguez@educacion.com',
    rol: 'Docente',
    cursos: [
      { nombre: 'Matemáticas - 4to Grado', calificacion: 'A', estado: 'Finalizado' },
      { nombre: 'Ciencias - 5to Grado', calificacion: 'B+', estado: 'En progreso' },
      { nombre: 'Historia - 6to Grado', calificacion: 'A-', estado: 'Finalizado' },
    ],
  };

  // Datos simulados para el reporte de progreso
  const reportes = [
    {
      nombre: 'Matemáticas - 4to Grado',
      progreso: 50,
      tareas: [
        { nombre: 'Tarea 1 - Operaciones Básicas', estado: 'Completada' },
        { nombre: 'Tarea 2 - Álgebra', estado: 'Pendiente' },
        { nombre: 'Tarea 3 - Fracciones', estado: 'Pendiente' },
      ],
    },
    {
      nombre: 'Ciencias - 5to Grado',
      progreso: 75,
      tareas: [
        { nombre: 'Tarea 1 - El Ciclo del Agua', estado: 'Completada' },
        { nombre: 'Tarea 2 - Estados de la Materia', estado: 'Completada' },
        { nombre: 'Tarea 3 - Ecosistemas', estado: 'Pendiente' },
      ],
    },
  ];

  return (
      <div className="container-fluid p-0">
        <h1 className="h3 mb-3">Perfil y Progreso del Usuario</h1>

        <div className="row">
          {/* Sección de Información Básica */}
          <div className="col-md-4">
            <div className="card mb-4">
              <div className="card-body text-center">
                <img
                  src="https://via.placeholder.com/150"
                  alt="Avatar de Usuario"
                  className="rounded-circle mb-3"
                  width="150"
                  height="150"
                />
                <h5 className="card-title">{docente.nombre}</h5>
                <p className="card-text">Correo: {docente.correo}</p>
                <p className="card-text">Rol: {docente.rol}</p>
              </div>
            </div>
          </div>

          {/* Sección de Historial de Actividades y Progreso */}
          <div className="col-md-8">
            <div className="card mb-4">
              <div className="card-header">
                <h5 className="card-title mb-0">Historial de Cursos</h5>
              </div>
              <div className="card-body">
                <ul className="list-group">
                  {docente.cursos.map((curso, index) => (
                    <li key={index} className="list-group-item d-flex justify-content-between align-items-center">
                      <div>
                        <strong>{curso.nombre}</strong> <br />
                        Estado: {curso.estado}
                      </div>
                      <span className="badge bg-primary rounded-pill">
                        Calificación: {curso.calificacion}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            {/* Sección de Progreso en los Cursos */}
            <h5 className="mb-3">Reporte de Progreso</h5>
            {reportes.map((reporte, index) => (
              <div className="card mb-4" key={index}>
                <div className="card-header">
                  <h5 className="card-title mb-0">Curso: {reporte.nombre}</h5>
                </div>
                <div className="card-body">
                  <h6>Progreso General: {reporte.progreso}%</h6>
                  <div className="progress mb-4">
                    <div
                      className="progress-bar"
                      role="progressbar"
                      style={{ width: `${reporte.progreso}%` }}
                      aria-valuenow={reporte.progreso}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>

                  <h6>Tareas:</h6>
                  <ul className="list-group mb-3">
                    {reporte.tareas.map((tarea, tareaIndex) => (
                      <li className="list-group-item" key={tareaIndex}>
                        {tarea.nombre}{' '}
                        <span
                          className={`badge bg-${
                            tarea.estado === 'Completada' ? 'success' : 'warning'
                          } float-end`}
                        >
                          {tarea.estado}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}

            {/* Sección de Configuración de Cuenta */}
            <div className="card">
              <div className="card-header">
                <h5 className="card-title mb-0">Configuración de Cuenta</h5>
              </div>
              <div className="card-body">
                <form>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">Cambiar Contraseña</label>
                    <input type="password" className="form-control" id="password" placeholder="Nueva Contraseña" />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Notificaciones</label>
                    <div className="form-check">
                      <input className="form-check-input" type="checkbox" id="emailNotifications" />
                      <label className="form-check-label" htmlFor="emailNotifications">
                        Recibir notificaciones por correo
                      </label>
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">Guardar Cambios</button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default PerfilDocenteConProgreso;
